import { prismFormatJSON } from 'utils/strings';

import Base from 'app/views/base';

import tmpl from './template';

export class DetailBlock {
  constructor({
    heading, wrapperSubClass, items, subViews,
  }) {
    this.heading = heading;
    this.wrapperSubClass = wrapperSubClass;
    this.items = items; // must be undefined or an fn that returns an array
    this.subViews = subViews || [];
    this.uid = parseInt(Math.random() * 100000, 10);
  }
}

export default Base.extend({
  compiledTemplate: tmpl,

  initialize({ showDetails }) {
    this.showDetails = showDetails;

    this.detailBlocks = this.showDetails.detailBlocks || [];
    this.detailBlocks.forEach(detailBlock => {
      detailBlock.subViews.forEach((subViewFn, idx) => {
        const subView = subViewFn(this.model);
        const id = this.model.get('id');
        const subviewName = this.computeDetailsBlockId(id, detailBlock.uid, idx);

        if (!this.getSubview(subviewName)) {
          this.addSubview(
            subviewName,
            `#${subviewName}`,
            subView,
          );
        }
      });
    });
  },

  context() {
    return {
      formattedJSON: prismFormatJSON(this.model.rawJSON),
      model: this.model,
      detailBlocks: this.detailBlocks,
      mainHeading: this.getMainHeading(this.showDetails.mainHeading),
      computeDetailsBlockId: this.computeDetailsBlockId.bind(this),
    };
  },

  computeDetailsBlockId(id, uid, idx) {
    return `${id}-detail_block-${uid}-${idx}`;
  },

  getMainHeading(heading) {
    if (typeof heading === 'function') {
      return heading(this.model);
    }
    return heading;
  },
});



// WEBPACK FOOTER //
// ./app/components/list/object_details/index.js